import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "rpp-filters" }
const _hoisted_2 = { class: "grid grid-cols-3 lg:grid-cols-3 gap-3 mt-2" }
const _hoisted_3 = { class: "flex items-center justify-end mt-3" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-undo mr-2" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-search mr-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_input = _resolveComponent("the-input")!
  const _component_the_select = _resolveComponent("the-select")!
  const _component_the_button = _resolveComponent("the-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("form", {
      onSubmit: _cache[15] || (_cache[15] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.search && _ctx.search(...args)), ["prevent"])),
      class: "bg-white border px-4 py-2"
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_the_input, {
          placeholder: "ID",
          value: _ctx.state.id,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.id) = $event))
        }, null, 8, ["value"]),
        _createVNode(_component_the_input, {
          placeholder: "Номер заказа",
          value: _ctx.state.ftl_order_id,
          "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.ftl_order_id) = $event))
        }, null, 8, ["value"]),
        _createVNode(_component_the_input, {
          placeholder: "Дата оборота (с)",
          value: _ctx.state.turnover_date_from,
          "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.turnover_date_from) = $event)),
          type: "date"
        }, null, 8, ["value"]),
        _createVNode(_component_the_input, {
          placeholder: "Дата оборота (по)",
          value: _ctx.state.turnover_date_to,
          "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.turnover_date_to) = $event)),
          type: "date"
        }, null, 8, ["value"]),
        _createVNode(_component_the_select, {
          class: "mt-2",
          placeholder: "Контрагент",
          "can-deselect": "",
          loading: _ctx.data_state.carriers.is_loading,
          failed: _ctx.data_state.carriers.is_failed,
          "error-text": "При получении списка контрагентов произошла ошибка",
          options: _ctx.data_state.carriers.list,
          value: _ctx.state.company_id,
          "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.company_id) = $event)),
          "infinite-scroll": "",
          onRefresh: _cache[5] || (_cache[5] = ($event: any) => (_ctx.loadCompanies(_ctx.data_state.carriers.pagination.current_page))),
          onLoadmore: _cache[6] || (_cache[6] = ($event: any) => (_ctx.loadMoreCompanies(_ctx.data_state.carriers.pagination.current_page + 1))),
          onSearch: _ctx.searchCompanies,
          onOptionBySearch: _ctx.unshiftFindedCompany
        }, null, 8, ["loading", "failed", "options", "value", "onSearch", "onOptionBySearch"]),
        _createVNode(_component_the_input, {
          placeholder: "Номер акта",
          value: _ctx.state.act_number,
          "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.state.act_number) = $event))
        }, null, 8, ["value"]),
        _createVNode(_component_the_input, {
          placeholder: "Дата акта",
          value: _ctx.state.act_date,
          "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.state.act_date) = $event)),
          type: "date"
        }, null, 8, ["value"]),
        _createVNode(_component_the_select, {
          class: "mt-2",
          "can-deselect": "",
          placeholder: "Статус",
          options: _ctx.STATUSES_RPK_RPP,
          value: _ctx.state.status_id,
          "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.state.status_id) = $event))
        }, null, 8, ["options", "value"]),
        _createVNode(_component_the_select, {
          class: "mt-2",
          "can-deselect": "",
          placeholder: "Город отправителя",
          loading: _ctx.data_state.cities.is_loading,
          failed: _ctx.data_state.cities.is_failed,
          "error-text": "При получении списка произошла ошибка",
          options: _ctx.data_state.cities.list,
          value: _ctx.state.from_city_id,
          "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.state.from_city_id) = $event)),
          onRefresh: _cache[11] || (_cache[11] = ($event: any) => (_ctx.loadCities(1)))
        }, null, 8, ["loading", "failed", "options", "value"]),
        _createVNode(_component_the_select, {
          class: "mt-2",
          "can-deselect": "",
          placeholder: "Город получателя",
          loading: _ctx.data_state.cities.is_loading,
          failed: _ctx.data_state.cities.is_failed,
          "error-text": "При получении списка произошла ошибка",
          options: _ctx.data_state.cities.list,
          value: _ctx.state.where_city_id,
          "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.state.where_city_id) = $event)),
          onRefresh: _cache[13] || (_cache[13] = ($event: any) => (_ctx.loadCities(1)))
        }, null, 8, ["loading", "failed", "options", "value"]),
        _createVNode(_component_the_select, {
          class: "mt-2",
          placeholder: "Логист",
          "can-deselect": "",
          loading: _ctx.data_state.logists.is_loading,
          failed: _ctx.data_state.logists.is_failed,
          "infinite-scroll": "",
          options: _ctx.data_state.logists.list,
          value: _ctx.state.user_id,
          "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.state.user_id) = $event)),
          onRefresh: _ctx.loadLogists,
          onLoadmore: _ctx.loadMoreLogists,
          onSearch: _ctx.searchLogists,
          onOptionBySearch: _ctx.unshiftFindedLogist
        }, null, 8, ["loading", "failed", "options", "value", "onRefresh", "onLoadmore", "onSearch", "onOptionBySearch"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_the_button, {
          class: "second text small mr-2",
          loading: _ctx.loading,
          onClick: _ctx.reset
        }, {
          default: _withCtx(() => [
            _hoisted_4,
            _createTextVNode(" Сброс ")
          ]),
          _: 1
        }, 8, ["loading", "onClick"]),
        _createVNode(_component_the_button, {
          class: "primary text small",
          loading: _ctx.loading,
          type: "submit"
        }, {
          default: _withCtx(() => [
            _hoisted_5,
            _createTextVNode(" Поиск ")
          ]),
          _: 1
        }, 8, ["loading"])
      ])
    ], 32)
  ]))
}